import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import { timestampInSeconds } from '../utils-hoist/time.js';
import { updateMetricSummaryOnActiveSpan } from '../utils/spanUtils.js';
import { DEFAULT_BROWSER_FLUSH_INTERVAL, SET_METRIC_TYPE } from './constants.js';
import { captureAggregateMetrics } from './envelope.js';
import { METRIC_MAP } from './instance.js';
import { sanitizeMetricKey, sanitizeTags, sanitizeUnit, getBucketKey } from './utils.js';

/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */
var BrowserMetricsAggregator = /*#__PURE__*/function () {
  // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
  // when the aggregator is garbage collected.
  // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry

  function BrowserMetricsAggregator(_client) {
    var _this = this;
    _classCallCheck(this, BrowserMetricsAggregator);
    this._client = _client;
    this._buckets = new Map();
    this._interval = setInterval(function () {
      return _this.flush();
    }, DEFAULT_BROWSER_FLUSH_INTERVAL);
  }

  /**
   * @inheritDoc
   */
  _createClass(BrowserMetricsAggregator, [{
    key: "add",
    value: function add(metricType, unsanitizedName, value) {
      var unsanitizedUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'none';
      var unsanitizedTags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var maybeFloatTimestamp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : timestampInSeconds();
      var timestamp = Math.floor(maybeFloatTimestamp);
      var name = sanitizeMetricKey(unsanitizedName);
      var tags = sanitizeTags(unsanitizedTags);
      var unit = sanitizeUnit(unsanitizedUnit);
      var bucketKey = getBucketKey(metricType, name, unit, tags);
      var bucketItem = this._buckets.get(bucketKey);
      // If this is a set metric, we need to calculate the delta from the previous weight.
      var previousWeight = bucketItem && metricType === SET_METRIC_TYPE ? bucketItem.metric.weight : 0;
      if (bucketItem) {
        bucketItem.metric.add(value);
        // TODO(abhi): Do we need this check?
        if (bucketItem.timestamp < timestamp) {
          bucketItem.timestamp = timestamp;
        }
      } else {
        bucketItem = {
          // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
          metric: new METRIC_MAP[metricType](value),
          timestamp: timestamp,
          metricType: metricType,
          name: name,
          unit: unit,
          tags: tags
        };
        this._buckets.set(bucketKey, bucketItem);
      }

      // If value is a string, it's a set metric so calculate the delta from the previous weight.
      var val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
      updateMetricSummaryOnActiveSpan(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "flush",
    value: function flush() {
      // short circuit if buckets are empty.
      if (this._buckets.size === 0) {
        return;
      }
      var metricBuckets = Array.from(this._buckets.values());
      captureAggregateMetrics(this._client, metricBuckets);
      this._buckets.clear();
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "close",
    value: function close() {
      clearInterval(this._interval);
      this.flush();
    }
  }]);
  return BrowserMetricsAggregator;
}();
export { BrowserMetricsAggregator };